import { useContext } from 'react';
import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import {
  getItemId,
  getMcvisID,
  getPageType,
  getRecentSearchTerms,
  getSvocId,
} from '../utils/assistant-context-utils';

/**
 * @returns {[
 *   ({ userQuestion: string }) => void,
 *   { data: object, loading: boolean, error: string }
 * ]}
 */
export const useGenerateQuestions = (session) => {
  const {
    channel,
    deliveryZip,
    isConsumerApp,
    store,
  } = useContext(ExperienceContext);

  const llmNameFS = useConfigService('fs:magic-apron-generate-questions-llm') || 'pro002';
  const [submitToBot, response] = useLazyDataModel('generateQuestions', {
    lazy: true,
  });

  const submitToGenerateQuestions = () => {
    submitToBot({ variables: {
      userContext: {
        userIdentities: {
          mcvisId: getMcvisID(),
          svocId: getSvocId(),
        },
        sessionId: session.sessionId,
        storeId: store.storeId,
        zipCode: deliveryZip,
        deviceType: channel === 'mobile' && isConsumerApp ? 'app' : channel,
        language: 'en-US',
      },
      pageContext: {
        pageType: getPageType(),
        referrerPage: window.document.referrer,
        timestamp: Date.now(),
        url: window.parent.location.href,
      },
      questionContext: {
        userQuestion: '',
        user_typed: 'N|null',
        itemId: getItemId(),
        recentSearchTerms: getRecentSearchTerms(),
      },
      suggestedQuestions: true,
      followUpQuestions: false,
      model_name: llmNameFS,
    } });
  };

  return [
    submitToGenerateQuestions,
    response,
  ];
};
